import weon from './weon';
import weonLightMode from './weonLightMode';
import grapChannels from './grapChannels';

export default {
  weon,
  weonLightMode,
  grapChannels,
};
